<i class="_icon"
   [ngClass]="'icon-' + icon"></i>
@if(textAnimated) {
<p class="_text">
    <span class="p1 p-l-3 p-r-1  no-wrap">
        {{textAnimated}}
    </span>
</p>
}

@if (isBusy) {
<div class="fill flex flex-middle flex-justify-center">
    <loader></loader>
</div>
}